"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexibleTeaserTheme = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var flexibleTeaserTheme = function (theme) {
    var componentTheme = {
        default: {
            wrapper: {
                fontColor: theme.base.color.text.indexOf('#fff') === -1 ? theme.base.color.text : '#444',
                fontColorNegative: '#fff',
                borderSize: '2px',
            },
        },
    };
    return __assign(__assign({}, theme), { component: {
            flexibleTeaser: theme.component.flexibleTeaser
                ? deepmerge_1.default(componentTheme, theme.component.flexibleTeaser)
                : componentTheme,
        } });
};
exports.flexibleTeaserTheme = flexibleTeaserTheme;
exports.default = exports.flexibleTeaserTheme;
//# sourceMappingURL=theme.js.map